import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	closeDateFilterLabel: {
		id: 'search-page.close-date-filter.label',
		defaultMessage: 'Close date',
		description: 'Label for close date filter in search page',
	},
	closeDateFilterUpdateButton: {
		id: 'search-page.close-date-filter.update-button',
		defaultMessage: 'Apply',
		description: 'Button to apply selected close date in search page',
	},
	closeDateFilterDateLabel: {
		id: 'search-page.close-date-filter.date-label',
		defaultMessage: 'Select date',
		description: 'Label for close date picker input in search page',
	},
	closeDateFilterDatePlaceholder: {
		id: 'search-page.close-date-filter.date-placeholder',
		defaultMessage: 'Select a date',
		description: 'Placeholder for close date picker input in search page',
	},
});
